'use client';

import React from 'react';
import { useRecoilState } from 'recoil';

import { isSearchOpenState } from '@/states/used-cars/filter-query.state';

import styles from './search-results.module.scss';

export default function SearchResultsWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isSearchOpen] = useRecoilState(isSearchOpenState);

  return (
    <div className={styles.bodyWrapper}>
      {isSearchOpen && <div className={styles.bodyWrapperBlur}></div>}
      {children}
    </div>
  );
}
